import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  RsuElectService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto,
} from '../../services/wealthlane-award-settlement-services';
import { hocMobileClose } from '../../utils/hoc/hocMobileClose';

const usePostElectionMethod = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseMutationResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto | undefined,
  unknown,
  any,
  unknown
> => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        RsuElectService.postApiAwardSettlementApiAppRSUElectSaveElection(payload)
      );
    },
    {
      onSuccess: async (
        // eslint-disable-next-line camelcase
        response: Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto | undefined
      ) => {
        if (response != null) {
          toast.success(<ToastComponent label='Success' message={`Election Method Added.`} />);
          void queryClient.invalidateQueries('getParticipantDashboardTaskSummery');
          void queryClient.invalidateQueries('getParticipantDashboardTask');
          hocMobileClose(navigate);
          navigate('/overview');
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostElectionMethod;
